import React from "react";
import "./CheckoutProduct.css";
import { useStateValue } from "./Context";

export default function CheckoutProduct({ id, price, title, img, rating, hidden }) {
  const [{ basket }, dispatch] = useStateValue();

  const removeHandler = () => {
    dispatch({
      type: "REMOVE_FROM_BASKET",
      id:id,
    });
  };
  return (
    <div className="checkoutProduct">
      <img className="checkoutproduct_image" src={img} alt="" />
      <div className="checkoutproduct_info">
        <p className="checkoutproduct_title">{title}</p>
        <p className="checkoutproduct_price">
          <small>$</small>
          <strong>{price}</strong>
        </p>
        <div className="checkoutproduct_rating">
          {Array(rating)
            .fill()
            .map((_, i) => (
              <p>🌟</p>
            ))}
        </div>
        {!hidden && (

          <button onClick={removeHandler}>Remove from Basket</button>
        )}
      </div>
    </div>
  );
}
